import { useMutation } from "@apollo/client";
import { AES } from "crypto-js";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  CANCEL_PAYMENT,
  CANCELLED,
  COMPLETE_SUCCESS,
  HANDLE_TRANSACTION_ERRORS,
  SUCCESS,
} from "../../../../Constants/constants";
import { extractUID } from "../../../../Services/helper";
import { IFRAME_TRANSACTION_ERROR } from "../../../Payment/query";

interface IPaymentIframeProps {
  src: string;
  handleSuccess?: any;
  handleFailure?: any;
  paymentType?: string;
}

const PaymentIframe = ({ src, handleSuccess, handleFailure, paymentType }: IPaymentIframeProps) => {
  const { iframeURL, iframeOrderId } = useSelector((state: any) => state.paymentDetails);
  const [width, setWidth] = useState<number>(0);

  const { ndsObj, emailContact, accountNumber, givenNameFamilyName } = useSelector(
    (state: any) => state.customerInfoDetails
  );
  const { cbstKey } = useSelector((state: any) => state.userInfo);
  const { paymentsMigrationToNDS, usi } = useSelector((state: any) => state.customerPlanDetails);
  const resolutions = {
    mobileResolution: window.screen.width >= 320 && window.screen.width < 500,
    tabletResolution: window.screen.width > 650 && window.screen.width <= 1024,
  };

  const [iframeTransactionError] = useMutation(IFRAME_TRANSACTION_ERROR, {
    onError: (error) => console.log(error),
  });

  const encryptPayload = (content: any, key: string) => {
    if (!key) {
      return undefined;
    }
    return AES.encrypt(JSON.stringify({ content }), key).toString();
  };

  useEffect(() => {
    let UID = src && extractUID(src);
    const messageHandler = (event: any) => {
      const data =
        ndsObj?.isNDS || paymentsMigrationToNDS
          ? event.data
          : !ndsObj?.isNDS && event?.data && JSON.parse(event.data);
      let uid;
      const isFailure =
        data?.subject === CANCEL_PAYMENT || (!ndsObj?.isNDS && data?.status === CANCELLED);
      const logPayload =
        data?.subject === HANDLE_TRANSACTION_ERRORS
          ? {
              accountNumber: accountNumber,
              email: emailContact?.emailAddress,
              hpfType: paymentType,
              usi: usi,
              isTokenized: false,
              channel: "myaccount",
              chaseUid: UID,
              name: `${givenNameFamilyName?.givenName ?? ""} ${
                givenNameFamilyName?.familyName ?? ""
              }`,
              chaseOrderid: iframeOrderId,
              payloadChase: {
                eventName: data?.subject,
                iframeURL: src,
                accountNumber: accountNumber,
                email: emailContact?.emailAddress,
                errorDetails: data,
              },
            }
          : {
              eventName: data?.subject,
              payloadChase: data,
              channel: "myaccount",
              ...(isFailure && { chaseOrderid: iframeOrderId }),
              chaseUid: UID,
              iframeURL: src,
              accountNumber: accountNumber,
              email: emailContact?.emailAddress,
              hpfType: paymentType,
              usi: usi,
              isTokenized:
                data?.content?.status === SUCCESS || data?.status === COMPLETE_SUCCESS
                  ? true
                  : false,
            };
      const encryptedPayload = cbstKey ? encryptPayload(logPayload, cbstKey) : "";
      const requestId = sessionStorage.getItem("addPaymentMethodRequestId") || undefined;
      try {
        // Log transaction-related errors emitted by the iframe
        if (data?.subject === HANDLE_TRANSACTION_ERRORS) {
          try {
            iframeTransactionError({
              variables: {
                transactionId: requestId,
                payload: encryptedPayload,
                saveResponse: true,
              },
            });
          } catch (e) {
            console.error(e);
          }
        }

        if (ndsObj?.isNDS || paymentsMigrationToNDS) {
          uid = UID;
        }

        if (
          ((ndsObj?.isNDS || paymentsMigrationToNDS) && data?.content?.status === SUCCESS) ||
          (!ndsObj?.isNDS && data?.status === COMPLETE_SUCCESS)
        ) {
          if (!ndsObj?.isNDS) {
            let content = {
              uid: data.paymentmethod_id,
            };

            data["content"] = content;

            data["txn_guid"] = "";
          }
          handleSuccess(data, uid, logPayload);
        } else if (
          data?.subject === CANCEL_PAYMENT ||
          (!ndsObj?.isNDS && data?.status === CANCELLED)
        ) {
          // iframeTransactionError({
          //   variables: {
          //     transactionId: requestId,
          //     payload: encryptedPayload,
          //     saveResponse: true,
          //   },
          // });
          handleFailure(data);
        }
      } catch (err) {
        console.log(err);
      }
    };

    window.addEventListener("message", messageHandler);
    return () => {
      window.removeEventListener("message", messageHandler);
    };
  }, []);

  useEffect(() => {
    if (resolutions?.mobileResolution) {
      setWidth(320);
    } else if (resolutions?.tabletResolution) {
      setWidth(550);
    } else {
      setWidth(700);
    }
  }, [resolutions]);

  return (
    <>
      {iframeURL !== null && (
        <iframe
          style={{
            border: "none",
            minHeight: "500px",
          }}
          src={src}
          data-testid="iframe"
          width={width}
          title="Embedded Content"></iframe>
      )}
    </>
  );
};

export default PaymentIframe;
